import type { RefObject } from 'react';
import { useCursorModeShortcut, useUndoRedoShortcut, type CursorMode } from '@bliks-io/ui';

interface UseEditorKeyboardArgs {
  containerRef: RefObject<HTMLElement | null>;
  onUndo: () => void | Promise<void>;
  onRedo: () => void | Promise<void>;
  setCursorMode: (mode: CursorMode) => void;
}

export function useEditorKeyboard({
  containerRef,
  onUndo,
  onRedo,
  setCursorMode
}: UseEditorKeyboardArgs): void {
  useUndoRedoShortcut(containerRef, { undo: onUndo, redo: onRedo });
  useCursorModeShortcut(setCursorMode);
}
